export const getFundDeclarations = (state) => {
    return state.fundDeclarations
};
